import React from "react";
import PropTypes from "prop-types";
import { Divider } from "@qgiv/core-donor";

const ReceiptStoreItem = ({
    attributes = [],
    formattedTotalItemAmount = "",
    formattedUnitCost = "",
    title = "",
    qtySold = 0,
}) => (
    <>
        <div className="col col--12 col--no-top-gutter">
            <div className="grid">
                <div className="col col--8">
                    <p>
                        {title} {`${qtySold > 1 ? `x ${qtySold}` : ""}`}
                        {attributes.length > 0 &&
                            attributes.map((attribute, i) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <small key={i}>
                                    <br />
                                    {attribute}
                                </small>
                            ))}
                    </p>
                </div>
                <div className="col col--4 -text--right">
                    <p>{formattedTotalItemAmount}</p>
                    {qtySold > 1 && (
                        <small>{`(${formattedUnitCost} each)`}</small>
                    )}
                </div>
            </div>
        </div>
        <Divider dashed />
    </>
);

ReceiptStoreItem.propTypes = {
    attributes: PropTypes.arrayOf(PropTypes.string),
    formattedTotalItemAmount: PropTypes.string.isRequired,
    formattedUnitCost: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    qtySold: PropTypes.number.isRequired,
};

export default ReceiptStoreItem;
